const productLogos = {
  facebook: true,
  'facebook-messenger': true,
  google: true,
  'google-ads': true,
  'google-adwords': true,
  'google-gmail': true,
  'google-groups': true,
  'hubspot-wordmark': true,
  'hubspot-wordmark-light': true,
  linkedin: true,
  'office-365': true,
  outlook: true,
  rivaliq: true,
  salesforce: true,
  shopify: true,
  slack: true,
  'slack-wordmark': true,
  'slack-wordmark-light': true,
  stripe: true,
  'stripe-wordmark': true
};
const isString = c => typeof c === 'string';
export const isProductLogo = illustrationName => {
  return isString(illustrationName) && Object.prototype.hasOwnProperty.call(productLogos, illustrationName);
};